import React, { Component } from 'react';
import { compose } from 'recompose';


import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';

import useStyles from '../../styles/SignIn'

import { withFirebase } from '../Firebase'

function withMyHook(Component) {
  return function Wrappedcomponent(props) {
    const classes = useStyles();
    return <Component {...props} classes={classes} />;
  }
}

const INITIAL_STATE = {
  passwordOne: '',
  passwordTwo: '',
  error: null,
};

class PasswordChange extends Component {
  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE };
  }

  onSubmit = event => {
    const { passwordOne } = this.state;

    this.props.firebase
      .doPasswordUpdate(passwordOne)
      .then(() => {
        this.setState({ ...INITIAL_STATE });
      })
      .catch(error => {
        this.setState({ error })
      });

    event.preventDefault();
  };

  onChange = event => {
    this.setState({ [event.target.name]: event.target.value })
  }

  render() {
    const { passwordOne, passwordTwo, error } = this.state;

    const isInvalid = passwordOne !== passwordTwo || passwordOne === '';

    const classes = this.props.classes;

    return(
      <Container component="main" maxWidth="xs">
            <CssBaseline />
            <div className={classes.paper}>
              <Avatar className={classes.avatar}>
                <LockOutlinedIcon />
              </Avatar>
              <Typography component="h1" variant="h5">
                Reset Password
              </Typography>
              <form className={classes.form} onSubmit={this.onSubmit} noValidate>
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  id="passwordOne"
                  label="New Password"
                  name="passwordOne"
                  autoComplete="Password"
                  autoFocus
                  onChange={this.onChange}
                />
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  id="passwordTwo"
                  label="Confirm New Password"
                  name="passwordTwo"
                  autoComplete="Password"
                  autoFocus
                  onChange={this.onChange}
                />
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                  disabled={isInvalid}
                >
                  Reset My Password
                </Button>
              </form>
            </div>
            <Box mt={8}>
            </Box>
            {error && <p>{error.message}</p>}
          </Container>
      // <form onSubmit={this.onSubmit}>
      //   <input
      //     name="passwordOne"
      //     value={passwordOne}
      //     onChange={this.onChange}
      //     type="password"
      //     placeholder="New Password"
      //   />
      //   <input
      //     name="passwordTwo"
      //     value={passwordTwo}
      //     onChange={this.onChange}
      //     type="password"
      //     placeholder="Confirm New Password"
      //   />
      //   <button disabled={isInvalid} type="submit">
      //     Reset My Password
      //   </button>
      //   {error && <p>{error.message}</p>}
      // </form>
    )
  }

};

  const PasswordChangeForm = compose(
    withFirebase,
    withMyHook,
  )(PasswordChange)

export default PasswordChangeForm;
